<template>
    <div class="container">
        <div class="row">
            <div class="col-12 p-0">
                <h1>Grand exchange</h1>
            </div>
        </div>

        <template v-if="!symbolSelected">
            <div class="row">
                <div class="col-12 p-0">
                    <p>
                        Check grand exchange offers by searching for items on this page
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 p-0">
                    <SearchBar v-model="query" @search="search"></SearchBar>
                </div>
            </div>

            <!-- Search results -->
            <div class="row mt-5">
                <table class="table table-striped table-dark">
                    <tbody>
                        <tr v-for="(symbol, index) in filteredSymbols" :key="index" @click="search(index, symbol)">
                            <td scope="row">{{index}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>

        <!-- Selected symbol -->
        <div class="row mt-3" v-else>
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h2>
                            {{selectedSymbol.symbol[0].toUpperCase()}}{{selectedSymbol.symbol.slice(1)}}
                        </h2>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-link text-white" @click="back">
                            <div class="chevron-left"></div> <u>Back</u>
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-5">
                        <!-- Chart here -->
                        <GEChart :chart-data="chartData" :options="chartOptions"></GEChart>
                    </div>

                    <div class="col-12">
                        <table class="table table-dark table-striped">
                            <thead>
                                <tr>
                                    <th>Type offer</th>
                                    <th class="text-right">Price</th>
                                    <th class="text-right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="offer in sortedOffers.buy" :key="offer.id">
                                    <td>{{offer.type}}</td>
                                    <td class="text-right">{{offer.price}}</td>
                                    <td class="text-right">{{offer.amount}}</td>
                                </tr>
                                <tr v-for="offer in sortedOffers.sell" :key="offer.id">
                                    <td>{{offer.type}}</td>
                                    <td class="text-right">{{offer.price}}</td>
                                    <td class="text-right">{{offer.amount}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchBar from "./SearchBar";
    import GEChart from "./GEChart";

    export default {
        components: {
            SearchBar,
            GEChart
        },

        data: function() {
            return {
                query: "",
                searchResults: [],
                symbols: {},

                selectedSymbol: {
                    symbol: "",
                    offers: {
                        buy: [],
                        sell: []
                    }
                },

                searchTimeout: null,
                filteredSymbols: {},
            }
        },

        mounted() {
            this.fetchSymbols();
        },

        watch: {
            query() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.filteredSymbols = this.filterSymbols();
                }, 350);
            }
        },

        computed: {
            symbolSelected() {
                return !!this.selectedSymbol.symbol;
            },

            sortedOffers() {
                let buyOffers = this.sortArray(this.selectedSymbol.offers.buy, (a, b) => a.price < b.price);
                let sellOffers = this.sortArray(this.selectedSymbol.offers.sell, (a, b) => a.price < b.price);
                return {
                    buy: buyOffers,
                    sell: sellOffers
                }
            },

            chartData() {
                return {
                    // Labels are the bottom axis labels
                    // Labels will be each unique price point for open offers
                    labels: this.chartLabels.map(o => "Price: " + o),
                    datasets: [
                        {
                            label: "Buy offers",
                            borderColor: "#ff0000",
                            data: this.chartDatasets.buy,
                            lineTension: 0,
                        },
                        {
                            label: "Sell offers",
                            borderColor: "#0088ff",
                            data: this.chartDatasets.sell,
                            lineTension: 0
                        }
                    ]
                }
            },

            chartLabels() {
                  return this.selectedSymbol.offers.buy.map(offer => offer.price)
                            .concat(this.selectedSymbol.offers.sell.map(offer => offer.price))
                            .filter((a, n, b) => b.indexOf(a) === n)
                            .sort((a, b) => a - b);
            },

            chartDatasets() {
                let buy = {};
                let sell = {};

                for (let offer of this.selectedSymbol.offers.buy) {
                    if (!buy[offer.price]) buy[offer.price] = offer.amount;
                    else buy[offer.price] += offer.amount;
                }
                for (let offer of this.selectedSymbol.offers.sell) {
                    if (!sell[offer.price]) sell[offer.price] = offer.amount;
                    else sell[offer.price] += offer.amount;
                }

                buy = Object.values(buy);
                sell = Object.values(sell);

                return {
                    // buy: buy.concat(new Array(this.chartLabels.length - buy.length).fill(-10000)),
                    buy,
                    sell: new Array(this.chartLabels.length - sell.length).fill(null).concat(sell)
                }
            },

            chartOptions() {
                return {
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 0,
                            }
                        }]
                    }
                }
            }
        },

        methods: {
            fetchSymbols() {
                this.$http.get("https://api.gameslabs.net/1.0.0/exchange/")
                .then(response => {
                    response.data.forEach(item => {
                        this.symbols[item.buy.name] = item.symbol;
                    });
                    this.filteredSymbols = this.filterSymbols();
                })
            },

            search(index, item) {
                this.selectedSymbol.symbol = index;

                this.$http.get("https://api.gameslabs.net/1.0.0/exchange/symbol/" + item)
                    .then(response => {
                        this.selectedSymbol.offers = response.data;
                    })
            },

            filterSymbols() {
                if (this.query === '') return this.symbols;

                let result = {};
                for (let symbol in this.symbols) {
                    if (symbol.toLowerCase().indexOf(this.query.toLowerCase()) >= 0) {
                        result[symbol] = this.symbols[symbol];
                    }
                }

                return result;
            },

            sortArray(arr, compareFn) {
                let result = [];
                for (let i = 0; i < arr.length; i++) {
                    let added = false;

                    for (let j = 0; j < result.length; j++) {
                        if (compareFn(arr[i], result[j])) {
                            result.splice(j, 0, arr[i]);
                            added = true;
                            break;
                        }
                    }

                    //If we weren't able to add it till the end, add it to the end
                    if (!added)
                        result.push(arr[i]);
                }
                return result;
            },

            back() {
                this.selectedSymbol = {
                    symbol: "",
                    offers: {
                        buy: [],
                        sell: []
                    }
                }
            }
        }
    }
</script>

<style scoped>

    .chevron-left {
        background-color: white;
        -webkit-mask: url(/static/chevron-left.svg) no-repeat center;
        mask: url(/static/chevron-left.svg) no-repeat center;
        mask-size: cover;

        width: 16px;
        height: 16px;
        display: inline-block;
        line-height: 24px;
    }

</style>